import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import SLLoginForm from '@/components/login/SLLoginForm.vue';
import SLSignupForm from '@/components/login/SLSignupForm.vue';
import SLVerifyEmailForm from '@/components/login/SLVerifyEmailForm.vue';
import SLVerifyTFAForm from '@/components/login/SLVerifyTFAForm.vue';
import SLForgotForm from '@/components/login/SLForgotForm.vue';
import SLConnectForm from '@/components/login/SLConnectForm.vue';
import { feSdk } from '@streamlabs-core/sl-one-fe-components-vue2';
import { EAnalyticsEvent } from '@/helpers/analytic';
import NotificationHelper from '@/helpers/notification';
import { Spinner } from 'streamlabs-beaker';

@Component({
  components: {
    SLSignupForm,
    SLLoginForm,
    SLForgotForm,
    SLVerifyEmailForm,
    SLVerifyTFAForm,
    SSpinner: Spinner,
  },
})
export default class LoginSignUp extends Base {
  get formComponent() {
    if (this.$route.path === '/verify-email') return SLVerifyEmailForm;
    if (this.$route.path === '/verify-tfa') return SLVerifyTFAForm;
    if (this.$route.path === '/login') return SLLoginForm;

    if (this.$route.path === '/signup') return SLSignupForm;
    if (this.$route.path === '/forgot') return SLForgotForm;

    if (this.slidModule.session) return SLConnectForm;

    return SLLoginForm;
  }

  mounted() {
    if (this.currentUser) {
      this.$router.push('/projects');
      return;
    }

    if (this.$route.query?.error) {
      NotificationHelper.error(this.$route.query?.message as string || 'An error has occurred.  Please try again in a few minutes.');
    }

    this.getSlidUser();
  }

  get isLoading(): boolean {
    return this.slidModule.loadingSession;
  }

  async getSlidUser() {
    if (this.slidModule.session) return;

    const session = await feSdk.api.user.getAuthUser()
      .catch(() => null);

    await this.slidModule.setSLIDSession(session);

    if (session) {
      this.$sla.sendEvent(EAnalyticsEvent.slNativeSessionLanding);
      this.$router.push('/verify-session');
    } else if (!this.slidModule.landingTracked) {
      this.slidModule.setLandingTracked(true);

      switch (this.$route.name) {
        case 'Login':
          this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginLanding);
          break;

        case 'Sign Up':
          this.$sla.sendEvent(EAnalyticsEvent.slNativeSignupLanding);
          break;

        default:
          const eventName = `${EAnalyticsEvent.slNativeLanding} ${this.$route.name}`;
          this.$sla.sendEvent(eventName as EAnalyticsEvent);
          break;
      }
    }

    await this.slidModule.setLoadingSession(false);
  };
}
